import { VIEW_TYPE_CHANGED } from "./updateViewType.action";
import { UPDATE_CONTEXT } from "./updateContext.action";
import { AnyAction, IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { ChangesType } from "../../types";
import { SET_CHANGES_GENERATED } from "./setChangesGeneratedDate.action";
import { updateObject } from "../../../common/util/UpdateObject";

export const workspaceChangesReducer: IPartialReducer<ChangesType> = (state: ChangesType, action: AnyAction) => {
    switch (action.type) {
        case SET_CHANGES_GENERATED: {
            return updateObject(state, {
                workspaceChanges: updateObject(state.workspaceChanges, {
                    dateOfGeneration: action.date,
                }),
            });
        }
        case VIEW_TYPE_CHANGED: {
            return updateObject(state, {
                workspaceChanges: updateObject(state.workspaceChanges, {
                    view: action.viewType,
                }),
            });
        }
        case UPDATE_CONTEXT: {
            return updateObject(state, {
                workspaceChanges: updateObject(state.workspaceChanges, {
                    context: action.context,
                }),
            });
        }
        default:
            if (!state) {
                return {};
            }
            return state;
    }
};
